<template>
    <div class="fg-wrapper">
        <div id="fg-canvas">
        </div>
        <transition v-if="canvasReady" name="fade">
            <Settings v-if="infoActive" @hidden="infoActive = false" ref="settings"></Settings>
        </transition>
      <b-col class="lifetime-amount d-flex align-items-center justify-content-center" v-if="displayLifetimeAmount && lifetimeAmount !== undefined">
        <span>{{ 'lifetime_amount' | lang }}: {{ lifetimeAmount | currency }}</span>
      </b-col>
      <div v-if="displayAgeDisclaimer && !explanationVisible && (!infoActive || !isMobile)" class="age-disclaimer">{{ 'age_disclaimer' | lang }}</div>
      <div v-if="canvasReady" id="fg-panel" :class="[{'mobile':isMobile, 'fg-panel-container':true, 'ticket-in-progress':ticketInProgress, 'game-played': amountWon !== false}]">
            <Message></Message>
          <b-row class="h-100">
                <b-col cols="0" md="1" class="left justify-content-center align-items-center d-none d-md-flex">
                </b-col>
                <b-col cols="12" md="10" class="middle pl-4 pr-4 pl-md-0 pr-md-0">
                    <b-row class="h-100">
                        <div class="balance col-3 col-md-4 text-right d-flex justify-content-start justify-content-md-end align-items-center">
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row" v-if="mode === 'real'"><span class="pr-0 pr-md-1">{{ 'balance' | lang }}:</span> <span>{{balance | currency}}</span></div>
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row" v-else-if="demoBalance"><span class="pr-0 pr-md-1">{{ 'demo_balance' | lang }}:</span> <span>{{balance | currency}}</span></div>
                            <span v-else>{{ 'demoMode' | lang}}</span>
                        </div>
                        <div class="winup col-6 col-md-4 pl-1 pr-1 pl-md-5 pr-md-5 d-flex justify-content-center align-items-center">
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row" v-if="!ticketInProgress && amountWon !== false && !parseFloat(amountWon)"><span>{{'noWinning' | lang}}</span></div>
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row" v-else-if="ticketInProgress || amountWon !== false"><span class="pr-0 pr-md-1">{{ 'total_win' | lang }}:</span> <span>{{amountWon | currency}}</span></div>
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row" v-else><span class="pr-0 pr-md-1">{{ 'win_up_to' | lang }}:</span> <span>{{winUp | currency}}</span></div>
                        </div>
                        <div class="price col-3 col-md-4 d-flex justify-content-end justify-content-md-start align-items-center">
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row ticket-price" :class="isSingleAmount ? 'disabled' : ''" @click="openPriceSelection" v-if="mode === 'real'">
                                <span class="pr-0 pr-md-1">{{ 'amount' | lang }}:</span><span>{{amount | currency}}</span>
                            </div>
                            <div class="justify-content-center align-items-center d-flex flex-column flex-md-row change-mode-to-real" @click="changeModeToReal" v-else>
                                <span class="pr-0 pr-md-1">{{ (realToHome ? 'backToLobby' : 'play_for_money') | lang }}</span>
                            </div>
                        </div>
                    </b-row>
                </b-col>
                <b-col cols="0" md="1" class="right justify-content-center align-items-center d-none d-md-flex">
                    <div class="time">
                        {{this.currentTimeString}}
                    </div>
                </b-col>
            </b-row>

            <transition name="fade">
                <div v-if="infoActive" class="settings-button d-flex justify-content-center align-items-center" @click="toggleInfo" key="toggleClose">
                    <img src="/fg/v2/img/icons/icon_cross.svg" alt="Close">
                </div>
                <div v-else class="settings-button d-flex justify-content-center align-items-center" @click="toggleInfo" key="toggleInfo">
                    <img src="/fg/v2/img/icons/icon_settings.svg" alt="Settings">
                </div>
            </transition>

            <div v-if="!infoActive && !showOpenAllButton && !showCustomPlayButton && !hidePlayButton" :class="[{'disabled': (!this.ticketInProgress && this.popGracefulPause), 'purchase-button d-flex justify-content-center align-items-center': true, 'flex-column with-additional-text': displayActionText}]" @click="purchase">
              <template v-if="displayActionText">
                <template v-if="mode == 'demo'">
                  <span class="action-text action-text-play">{{ 'play_demo' | lang }}</span>
                  <span class="action-text-additional">{{ 'play_demo_additional' | lang }}</span>
                </template>
                <template v-else>
                  <span class="action-text action-text-play">{{ playTextExploded[0] }}</span>
                  <span class="action-text-additional">{{ playTextExploded[1] }}</span>
                </template>
              </template>
              <img v-else src="/fg/v2/img/icons/icon_play.svg" alt="Play">
            </div>

            <div v-if="!infoActive && showOpenAllButton" :class="[{'disabled':((!this.ticketInProgress && this.popGracefulPause) || openAllButtonDisabled), 'open-all-button d-flex justify-content-center align-items-center':true, 'flex-column with-additional-text': displayActionText}]" @click="openAll">
                <template v-if="displayActionText">
                  <span class="action-text">{{ scratchTextExploded[0] }}</span>
                  <span class="action-text-additional">{{ scratchTextExploded[1] }}</span>
                </template>
                <img v-else src="/fg/v2/img/icons/icon_open-all.svg" alt="Open All">
            </div>

            <div v-if="!infoActive && showCustomPlayButton" :class="[{'disabled':((!this.ticketInProgress && this.popGracefulPause) || customPlayButtonDisabled), 'custom-play-button d-flex justify-content-center align-items-center':true, 'flex-column with-additional-text': displayActionText}]" @click="customPlayButtonEvent">
              <template v-if="displayActionText && customPlayButtonText">
                <span class="action-text">{{ customPlayButtonTextExploded[0] }}</span>
                <span class="action-text-additional">{{ customPlayButtonTextExploded[1] }}</span>
              </template>
              <img v-else :src="`/fg/v2/img/icons/${showCustomPlayButton}`" alt="Play">
            </div>
        </div>
      <div class="ticket-barcode" v-if="(!ticketInProgress || displayBarcode) && ticketBarcode">{{ ticketBarcode }}</div>
        <div id = "explanation-transition" v-if = "explanationTemplateExists">
            <transition id="explanation" name="fade">
                <Explanation v-show="explanationVisible"> </Explanation>
            </transition>
        </div>
      <PopClientComponent v-if="popParameters" :parameters="popParameters"></PopClientComponent>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import Settings from '@fg/base/components/partials/settings/Container';
import Message from '@fg/base/components/partials/Message';
import Explanation from '@fg/base/components/partials/Explanation';
import { redirectLogin } from "@fg/base/helpers";
import PopClientComponent from "./partials/settings/PopClientComponent";
import lang from '../filters/lang';

export default {
    components: {PopClientComponent, Settings, Message, Explanation },
    data() {
        return {
            infoActive: false,
            currentTimeString: '',
            explanationTemplateExists: !!Config.explanation_template,
            popParameters: Config.popParameters,
            displayAgeDisclaimer: !!(Config.assets.settings && Config.assets.settings.age_disclaimer && Config.lang.age_disclaimer),
            displayLifetimeAmount: Config.display_lifetime_amount,
            displayActionText: Config.assets.settings && Config.assets.settings.action_buttons_text,
            displayBarcode: Config.assets.settings && Config.assets.settings.display_barcode,
        };
    },
    computed: {
        ...mapState([
            'relayMethods',
            'ticketInProgress',
            'canvasReady',
            'balance',
            'amountWon',
            'device',
            'mute',
            'isLogged',
            'mode',
            'currentAmount',
            'explanationVisible',
            'showOpenAllButton',
            'openAllButtonDisabled',
            'showCustomPlayButton',
            'customPlayButtonDisabled',
            'popGracefulPause',
            'lifetimeAmount',
            'hidePlayButton',
            'customPlayButtonText',
            'ticketBarcode',
            'ticketInProgress',
        ]),
        ...mapGetters(['winUp']),
        isMobile() {
            return this.device === 'mobile';
        },
        amount() {
            return this.$store.state.currentAmount.amount * this.$store.state.ticketsQuantity;
        },
        demoBalance() {
          return Config.demo_balance;
        },
        realToHome() {
          return Config.real_to_home;
        },
        isSingleAmount() {
          return Config.amounts.length == 1;
        },
        customPlayButtonTextExploded() {
          if (this.customPlayButtonText) {
            const translated = lang(this.customPlayButtonText)
            return translated.split(' ');
          }
        },
      playTextExploded() {
        const translated = lang('play')
        return translated.split(' ');
      },
      scratchTextExploded() {
        const translated = lang('scratch')
        return translated.split(' ');
      },
    },
    methods: {
        ...mapMutations(['toggleMute', 'setMessage']),
        showControls() {
          if(!this.ticketInProgress && this.popGracefulPause) {
            return;
          }

            return true;
        },
        purchase() {
            if(!this.canvasReady || this.ticketInProgress) {
                return;
            }

            if(!this.ticketInProgress && this.popGracefulPause) {
              return;
            }

            this.relayMethods.purchase();
        },
        openAll() {
            if(this.openAllButtonDisabled) {
                return;
            }

            this.relayMethods.openAll();
        },
        customPlayButtonEvent() {
            if(this.customPlayButtonDisabled) {
                return;
            }

            if(!this.ticketInProgress && this.popGracefulPause) {
              return;
            }

            this.relayMethods.customPlayButtonEvent();
        },
        currentTime() {
            let date = Config.replay_datetime ? new Date(Config.replay_datetime) : new Date();
            let hh = date.getHours();
            let mm = date.getMinutes();

            if(mm < 10) {
                mm = '0' + mm;
            }

            this.currentTimeString = `${hh}:${mm}`;
        },
        toggleInfo() {
            if (!this.ticketInProgress && this.popGracefulPause) {
              return;
           }

            this.infoActive = !this.infoActive;
        },
        openPriceSelection() {
            if (Config.amounts.length == 1) {
              return;
            }

            if(!this.ticketInProgress && this.popGracefulPause) {
              return;
            }

            this.infoActive = true;

            if(this.$refs.settings) {
                this.$refs.settings.showSettings();
            }
        },
        changeModeToReal() {
            if(!this.canvasReady || this.ticketInProgress) {
                return;
            }

            if (!this.ticketInProgress && this.popGracefulPause) {
              return;
            }

            this.relayMethods.changeModeToReal();
        }
    },
    created: function () {
      if (Config.player_text) {
        this.setMessage({
          message: Config.player_text,
          callback: {
            title: 'ok',
            callback: () => {
              if (Config.player_action === 'reload') {
                location.reload();
              }
            },
          }
        });
      } else {
        if(this.mode === 'real' && !this.isLogged && !Config.replay_id) {
          this.setMessage(
              {
                title: 'please_login',
                message:'in_order_to_buy',
                callback: {
                  title:'ok',
                  callback:() => {
                    if (Config.login_page) {
                      redirectLogin();
                    } else {
                      parent.postMessage({ auth: true }, '*');
                      location.reload();
                    }
                  },
                }
              }
          );
        }
      }

      this.currentTime();

      setInterval(() => {
          this.currentTime();
      }, 1000);
    }
}
</script>


<style scoped>
    #explanation-transition .fade-leave-active {
        transition: opacity .6s;
    }
    #explanation-transition .fade-enter, #explanation-transition .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
</style>